import { Component, OnInit } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { IconService, Icon } from '@dx/platform-components';
import { faPhoneAlt, faSearch } from '@fortawesome/pro-light-svg-icons';
import { faFolders } from '@fortawesome/pro-solid-svg-icons';

import { AuthService } from '../../auth/auth.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'dx-app-navbar',
  templateUrl: './app-navbar.component.html',
  styleUrls: ['./app-navbar.component.scss']
})
export class AppNavbarComponent implements OnInit {
  hasError$ = new Subject<boolean>();
  randomIcon: Icon;

  iconStore = {
    faFolders,
    faPhoneAlt,
    faSearch
  };

  constructor(public authService: AuthService, private iconService: IconService, private navigationService: NavigationService) { }

  get hasNavbar() {
    return this.navigationService.isDashboardActive();
  }

  ngOnInit() {
    this.randomIcon = this.iconService.randomIcon();
  }

  getLinkIcon(icon: string) {
    return this.iconStore[icon] || this.randomIcon.icon;
  }
}
